/**
 * Formata uma data ISO 8601 para o formato brasileiro com hora
 * @param {string} isoDate - Data no formato ISO 8601 (ex: 2026-02-03T20:19:56.865Z)
 * @returns {string} Data formatada (ex: 03/02/2026 às 20h19min)
 */
export const formatDateTimeWithLocale = (isoDate: string): string => {
  if (!isoDate) return ''

  const date = new Date(isoDate)

  const parts = new Intl.DateTimeFormat('pt-BR', {
    timeZone: 'America/Sao_Paulo',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  }).formatToParts(date)

  const get = (type: Intl.DateTimeFormatPartTypes) => parts.find((part) => part.type === type)?.value || ''

  return `${get('day')}/${get('month')}/${get('year')} às ${get('hour')}h${get('minute')}min`
}
